import React from "react";
import { Link } from "react-router-dom";
import "@/landing.css";

/** Minimalist checkout layout — no marketing header/footer. Tiny brand mark + secure badge. */
export default function CheckoutLayout({ children }) {
  return (
    <div className="mkt-root vbs-checkout-root">
      <div className="vbs-checkout-topstrip">
        <Link to="/dashboard" className="vbs-checkout-brand">
          <img src="/brand/icon-gold.png" alt="" />
          <span>ViralBookSuite</span>
        </Link>
        <span className="vbs-checkout-secure">SECURE · 256-BIT SSL · STRIPE</span>
      </div>
      <main className="vbs-checkout-main">{children}</main>
    </div>
  );
}
